import PropTypes from 'prop-types'
import React, { Component } from 'react'
import FormLoader from './FormLoader'
import styles from './form.styl'

export default class Form extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    onSubmit: PropTypes.func,
    encType: PropTypes.string,
    loading: PropTypes.bool,
    autoComplete: PropTypes.string
  }
  static defaultProps = {
    itemsCount: 4,
    withImage: false,
    loading: false,
    encType: 'application/x-www-form-urlencoded',
    autoComplete: true
  }

  render() {
    const { loading, children, encType, onSubmit, autoComplete } = this.props

    return (
      <div className={styles.stretch}>
        {loading && <FormLoader {...this.props} />}
        {!loading &&
          <form
            className={styles.stretch}
            onSubmit={onSubmit}
            encType={encType}
            autoComplete={autoComplete}
          >
            {children}
          </form>}
      </div>
    )
  }
}
